import React from "react";
import LegalShell, { LegalSection } from "../components/ui/LegalShell";

const TERMS = [
  {
    id: "acceptance",
    title: "Acceptance of Terms",
    body: `By accessing or using Game Goblin, you agree to be bound by these Terms & Conditions and our Privacy Policy. If you do not agree, please do not use our website.`,
  },
  {
    id: "use",
    title: "Use of the Service",
    body: `Game Goblin is provided for personal, non-commercial use only. You agree not to use the site for any unlawful purpose or in a way that may damage or disrupt the service. We reserve the right to modify, suspend, or discontinue any part of the website at any time without prior notice.`,
  },
  {
    id: "accounts",
    title: "Accounts and User Data",
    body: `If you create an account or sign up with your email, you are responsible for keeping your information accurate and secure. We collect certain information such as your email and your interactions (liked or saved games) to improve our recommendations and overall functionality. Please see our Privacy Policy for more details on how we handle your data.`,
  },
  {
    id: "ip",
    title: "Intellectual Property",
    body: `All content on Game Goblin, including the name, logo, design, and original text, is the property of Game Goblin. Game data, images, and descriptions may include material provided by third-party sources such as IGDB or RAWG, which remain the property of their respective owners. You may not copy, reproduce, distribute, or publicly display any content from this website without permission.`,
  },
  {
    id: "third-party",
    title: "Third-Party Links and Content",
    body: `Game Goblin may include links or data from external websites and APIs. We are not responsible for the accuracy, availability, or content of those external sources. Your use of third-party services is at your own risk.`,
  },
  {
    id: "liability",
    title: "Disclaimer and Limitation of Liability",
    body: `Game Goblin is provided "as is" without warranties of any kind. We do not guarantee that the website will always be available, error-free, or provide accurate game information. To the fullest extent permitted by law, Game Goblin shall not be liable for any direct or indirect damages resulting from your use of the website.`,
  },
  {
    id: "changes",
    title: "Changes to These Terms",
    body: `We may update or modify these Terms & Conditions from time to time. Any changes will be posted on this page, and your continued use of the service after such changes constitutes acceptance of the updated terms.`,
  },
];

const infoCards = [
  { icon: "⚖️", title: "Legal", color: "#efbf04", text: "Terms and usage information for Game Goblin." },
  { icon: "💬", title: "Support", color: "#21cbf3", text: "Contact info and assistance." },
  { icon: "🔄", title: "Updates", color: "#9701fb", text: "We may update terms periodically; check this page for changes." },
];

const TermsPage = () => {
  const today = "October 16, 2025";
  const toc = TERMS.map((s, i) => ({ id: s.id, label: `${i + 1}. ${s.title}` }));

  return (
    <LegalShell
      icon="⚖️"
      title="Terms & Conditions"
      updated={today}
      intro={`Welcome to Game Goblin ("we", "our", "us"). By accessing or using our website and services, you agree to these Terms & Conditions. Please read them carefully before using the site.`}
      toc={toc}
      infoCards={infoCards}
    >
      {TERMS.map((s, i) => (
        <LegalSection key={s.id} id={s.id} number={i + 1} title={s.title}>
          <p>{s.body}</p>
        </LegalSection>
      ))}

      <LegalSection id="contact" number={TERMS.length + 1} title="Contact">
        <p>
          If you have any questions about these Terms &amp; Conditions, please contact us at{" "}
          <a
            href="mailto:info@gamegoblin.eu"
            className="text-brand-gold font-semibold hover:underline"
          >
            info@gamegoblin.eu
          </a>
          .
        </p>
      </LegalSection>
    </LegalShell>
  );
};

export default TermsPage;
